/**
 * @generated SignedSource<<0123a671a31ad15586abd72be2cddc41>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Notifications$data = {
  readonly notifications: {
    readonly unseenNotificationCount: number;
  } | null | undefined;
  readonly " $fragmentType": "Nav4Notifications";
};
export type Nav4Notifications$key = {
  readonly " $data"?: Nav4Notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Notifications">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4Notifications",
  "selections": [
    {
      "concreteType": "InfluentsNotificationQuery",
      "kind": "LinkedField",
      "name": "notifications",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "unseenNotificationCount"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "ce43309d6cb695185a3f170824d9c925";

export default node;
